import { fromJS } from 'immutable';
import { visibleColumns } from './volcanoEventReduxConstants';
import { resolveErrors } from '../../../../components/grid/resultGridUtils';


export const CLEAR_VOLCANO_EVENTS_DATA = 'CLEAR_VOLCANO_EVENTS_DATA';

export const GET_VOLCANO_EVENT_DATA_REGION_REQUEST = 'GET_VOLCANO_EVENT_DATA_REGION_REQUEST';
export const GET_VOLCANO_EVENT_DATA_REGION_SUCCESS = 'GET_VOLCANO_EVENT_DATA_REGION_SUCCESS';
export const GET_VOLCANO_EVENT_DATA_REGION_FAILURE = 'GET_VOLCANO_EVENT_DATA_REGION_FAILURE';

export const DELETE_VOLCANO_EVENT_DATA_REQUEST = 'DELETE_VOLCANO_EVENT_DATA_REQUEST';
export const DELETE_VOLCANO_EVENT_DATA_SUCCESS = 'DELETE_VOLCANO_EVENT_DATA_SUCCESS';
export const DELETE_VOLCANO_EVENT_DATA_FAILURE = 'DELETE_VOLCANO_EVENT_DATA_FAILURE';

export const VOLCANO_EVENT_DATA_TOGGLE_COLUMN = 'VOLCANO_EVENT_DATA_TOGGLE_COLUMN';

export const VOLCANO_EVENT_DATA_SAVE_OPEN_CONFIRMATION = 'VOLCANO_EVENT_DATA_SAVE_OPEN_CONFIRMATION';
export const VOLCANO_EVENT_DATA_SAVE_CANCEL_CONFIRMATION = 'VOLCANO_EVENT_DATA_SAVE_CANCEL_CONFIRMATION';
export const VOLCANO_EVENT_DATA_CANCEL_EDIT = 'VOLCANO_EVENT_DATA_CANCEL_EDIT';
export const VOLCANO_EVENT_DATA_EDIT = 'VOLCANO_EVENT_DATA_EDIT';
export const VOLCANO_EVENT_DATA_BULK_EDIT_REQUEST = 'VOLCANO_EVENT_DATA_BULK_EDIT_REQUEST';
export const VOLCANO_EVENT_DATA_BULK_EDIT_SUCCESS = 'VOLCANO_EVENT_DATA_BULK_EDIT_SUCCESS';
export const VOLCANO_EVENT_DATA_BULK_EDIT_FAILURE = 'VOLCANO_EVENT_DATA_BULK_EDIT_FAILURE';

const initialState = fromJS({
  deleting: false,

  fetchedRegions: false,
  regions: [],

  visibleColumns,

  saving: false,
  formData: {},
  initialFormData: {},
  editConfirmationOpen: false,
  errors: {},
  editing: false,
  initialValues: {},

});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const volcanoEventDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case VOLCANO_EVENT_DATA_EDIT:
      return state.merge(fromJS({
        errors: {},
        editing: true,
        initialValues: action.initialValues,
      }));
    case VOLCANO_EVENT_DATA_CANCEL_EDIT:
      return state.merge(fromJS({
        errors: {},
        editing: false,
        initialValues: {},
      }));

    case VOLCANO_EVENT_DATA_SAVE_OPEN_CONFIRMATION:
      return state.merge(fromJS({
        formData: action.formData,
        initialFormData: action.initialFormData,
        editConfirmationOpen: true,
      }));
    case VOLCANO_EVENT_DATA_SAVE_CANCEL_CONFIRMATION:
      return state.merge(fromJS({
        formData: {},
        initialFormData: {},
        editConfirmationOpen: false,
      }));

    case VOLCANO_EVENT_DATA_BULK_EDIT_REQUEST:
      return state.merge(fromJS({
        saving: true,
        errors: {},
      }));
    case VOLCANO_EVENT_DATA_BULK_EDIT_SUCCESS:
      return state.merge(fromJS({
        saving: false,
        errors: {},
      }));
    case VOLCANO_EVENT_DATA_BULK_EDIT_FAILURE:
      return state.merge(fromJS({
        saving: false,
        errors: resolveErrors(action.response),
      }));

    case CLEAR_VOLCANO_EVENTS_DATA:
      return initialState.merge(fromJS({
        visibleColumns: state.get('visibleColumns'),
      }));


    case VOLCANO_EVENT_DATA_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleColumns: action.visibleColumns,
      }));

    case DELETE_VOLCANO_EVENT_DATA_REQUEST:
      return state.merge(fromJS({
        deleting: true,
      }));
    case DELETE_VOLCANO_EVENT_DATA_SUCCESS:
    case DELETE_VOLCANO_EVENT_DATA_FAILURE:
      return state.merge(fromJS({
        deleting: false,
      }));


    case GET_VOLCANO_EVENT_DATA_REGION_REQUEST:
      return state.merge(fromJS({
        fetchedRegions: false,
      }));
    case GET_VOLCANO_EVENT_DATA_REGION_SUCCESS:
      return state.merge(fromJS({
        fetchedRegions: true,
        regions: action.response.items,
      }));
    case GET_VOLCANO_EVENT_DATA_REGION_FAILURE:
      return state.merge(fromJS({
        fetchedRegions: true,
      }));


    default:
      return state;
  }
};
